import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const StyledText = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    padding: 20px 0;
  }
`;
